import Lottie from 'lottie-react'
import success from "../../assets/lottie/success.json";
import "./review.css"
import FlashpeImg from "../../assets/images/spalsh.png";

const ReviewDone = () => {
  return (
    <>
        <img
            src={FlashpeImg}
            alt=""
            width={"120px"}
            height={"120px"}
            className="flashpeImg"
          />
    <div className='review-done-container '>

       <h3>Review Submitted 🌟</h3>
        <Lottie 
            animationData={success}   
            className="lottie-sucess"
            loop={false}
         />
         <span>
        Your review adds the perfect kick to our flavor game! Spice it up, and let the tasteful improvements roll in.🌶🍔🚀
    </span>
    </div>
    </>
  )
}

export default ReviewDone